import { SxProps } from '@mui/material'

interface PartnersStyles {
  container: SxProps
  listItem: SxProps
  colorBar: SxProps
  partnerName: SxProps
}

export const partnersStyles: PartnersStyles = {
  container: {
    px: 1.5,
    py: 1,
    mx: 1.5,
    my: 0.2,
    backgroundColor: 'background.default',
    borderRadius: 3,
    borderColor: 'border.secondary',
    borderWidth: 1,
    borderStyle: 'solid',
    boxShadow: '0 1px 2px 0 rgba(10, 13, 18, 0.05)',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 2,
    cursor: 'pointer',
    overflow: 'hidden',
    px: 2,
    py: 1.5,
    gap: 1.5,
    textDecoration: 'none',
  },

  colorBar: {
    width: 5,
    height: 24,
    borderRadius: 1,
  },

  partnerName: {
    typography: 'textMdSemibold',
    textTransform: 'capitalize',
    color: 'text.primary900',
  },
}
